<template>
  <b-card-code
      title="Új hozzáadása"
  >
    <!-- form -->
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>

          <b-col md="6">
            <b-form-group
                label="Dátum"
            >
              <validation-provider
                  #default="{ errors }"
                  name="dátum"
                  rules="required"
                  vid="date"
              >
                <b-input-group>
                  <b-form-input
                      v-model="formData.date"
                      type="text"
                      placeholder="ÉÉÉÉ-HH-NN"
                      autocomplete="off"
                      :formatter="formatDateAllowedSymbols"
                      show-decade-nav
                      required
                  />

                  <b-input-group-append>
                    <b-form-datepicker
                        v-model="formData.date"
                        size="sm"
                        show-decade-nav
                        button-only
                        right
                        :locale="$i18n.locale"
                        v-bind="labels[$i18n.locale] || {}"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
                label="Típus"
            >
              <validation-provider
                  #default="{ errors }"
                  name="típus"
                  rules="required"
                  vid="type"
              >
                <v-select
                    v-model="formData.type"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="typeOptions"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- submit button -->
          <b-col class="mt-1">
            <b-button
                variant="primary"
                type="submit"
                class="float-right"
                @click.prevent="submitForm"
            >
              Mentés
            </b-button>
            <cancel-and-g-o-t-o-previous-page class="mr-2"/>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
  BFormInput,
  BFormGroup,
  BInputGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BInputGroupAppend,
  BFormDatepicker,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  required,
} from '@validations'
import cancelAndGOTOPreviousPage from '@/views/pages/_components/_helper/cancelAndGOTOPreviousPage'
import labels from '@/libs/datepicker/labels'
import {formatDateAllowedSymbols} from "@core/utils/filter";

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormDatepicker,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    vSelect,
    cancelAndGOTOPreviousPage,
  },
  data() {
    return {
      role: 'reservation',
      formData: {
        date: '',
        type: '',
      },
      typeOptions: [],
      labels,
      formatDateAllowedSymbols,
      required,
    }
  },
  created() {
    this.$store.dispatch('reservationSpecialDayTypes').then(response => {
      this.typeOptions = response.data.values
      this.formData.type = this.typeOptions[0]
    })
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // clone formData
          let fd = JSON.parse(JSON.stringify(this.formData))
          fd.type = this.formData.type.value

          this.$store.dispatch('storeReservationSpecialDay', fd).then(response => {
            this.$helpers.showSuccessToast()

            this.$acl.canListPermission(this.role)
                ? this.$router.push({name: 'reservation-special-days'})
                : this.$router.go(-1)
          }).catch(error => {
            if (error.response.status === 422) {
              this.$refs.simpleRules.setErrors(error.response.data.errors)
            } else {
              this.$helpers.showErrorToast(error.toString())
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
